import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareClassicProformaIssueFormsDirectEmbedRoute: InvariantJiraRoute = {
	name: 'classic-software-proforma-issue-forms-direct-embed',
	path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
	exact: true,
};
